import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";      // ❶ add this
import LanguageToggle from "./LanguageToggle.jsx";
import { useTranslation } from "react-i18next";
function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout } = useAuth();                     // ❷ get user + logout
  const isAdmin = user?.role === "admin";
  const { t } = useTranslation();
  return (
    <nav className="bg-gray-800 text-white">
      <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
        <h1 className="text-xl font-bold">CiviSpec</h1>
        <ul className="hidden md:flex space-x-6 items-center">
          <li><Link to="/" className="hover:underline">Home</Link></li>
          <li><Link to="/about" className="hover:underline">About</Link></li>
          <li><Link to="/services" className="hover:underline">Services</Link></li>
          <li><Link to="/contact" className="hover:underline">Contact</Link></li>
          <li><Link to="/disclaimer" className="hover:underline">{t("nav.disclaimer")}</Link></li>
          <li>
            <Link to="/tools" className="hover:underline text-sky-300">
              {t("nav.tools")}
            </Link>
          </li>
          {isAdmin && <li><Link to="/admin" className="hover:underline">Admin</Link></li>}
          <li><LanguageToggle /></li>
          <li><Link to="/start" className="hover:underline text-yellow-300 font-semibold">Start</Link></li>
          {user && (                                       // ❸ show logout when logged in
            <li>
              <button type="button" onClick={logout} className="hover:underline">
                Log out
              </button>
            </li>
          )}
        </ul>

        <button
          className="md:hidden text-white focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>
      </div>

      {menuOpen && (
        <ul className="md:hidden px-4 pb-4 space-y-2 bg-gray-700">
          <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
          <li><Link to="/about" onClick={() => setMenuOpen(false)}>About</Link></li>
          <li><Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link></li>
          <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link></li>
          <li><Link to="/disclaimer" onClick={() => setMenuOpen(false)}>{t("nav.disclaimer")}</Link></li>
          <li>
            <Link to="/tools" onClick={() => setMenuOpen(false)} className="text-sky-300">
              {t("nav.tools")}
            </Link>
          </li>
          {isAdmin && (
            <li><Link to="/admin" onClick={() => setMenuOpen(false)}>Admin</Link></li>
          )}
          <li><LanguageToggle /></li>
          <li><Link to="/start" onClick={() => setMenuOpen(false)} className="text-yellow-300 font-semibold">Start</Link></li>
          {user && (
            <li>
              <button
                type="button"
                onClick={() => {
                  logout();
                  setMenuOpen(false);
                }}
                className="hover:underline"
              >
                Log out
              </button>
            </li>
          )}
        </ul>
      )}
    </nav>
  );
}

export default Navbar;